import { PolicyEvaluate } from '../interfaces/policy-evaluate.interface';

/** Stub: DriverEligibilityPolicy evaluate. */
export const DriverEligibilityPolicy: PolicyEvaluate<
	unknown,
	boolean,
	Record<string, unknown>
> = {
	evaluate(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): boolean {
		return true;
	},
};
